import { render, staticRenderFns } from "./DelButCmp.vue?vue&type=template&id=4a56a2b8"
import script from "./DelButCmp.vue?vue&type=script&lang=js"
export * from "./DelButCmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a56a2b8')) {
      api.createRecord('4a56a2b8', component.options)
    } else {
      api.reload('4a56a2b8', component.options)
    }
    module.hot.accept("./DelButCmp.vue?vue&type=template&id=4a56a2b8", function () {
      api.rerender('4a56a2b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/costManagement/costsFee/cmp/DelButCmp.vue"
export default component.exports